// Selectors


import { RootState } from '../../store';

export const issueVcSelector = (state: RootState) => state.issueVcState
